"use strict";

exports.__esModule = true;
exports.calculatePreferencesView = void 0;
var _types = require("../../types");
const calculatePreferencesView = () => {
  // TODO: Implement the actual logic based on booking settings
  // For now, returning hardcoded example as requested
  return {
    [_types.PreferenceType.STAFF_MEMBER]: {
      displayOn: _types.DisplayOn.CALENDAR
    },
    [_types.PreferenceType.DYNAMIC_PRICE]: {
      displayOn: _types.DisplayOn.NONE
    },
    [_types.PreferenceType.LOCATION]: {
      displayOn: _types.DisplayOn.PREFERENCE_MODAL
    }
  };
};
exports.calculatePreferencesView = calculatePreferencesView;
//# sourceMappingURL=calculatePreferencesView.js.map